export type SignupAccessUser = {
    is_logged_in: boolean;
    is_free: boolean;
};

export function shouldDisableSignupEmailField(user: SignupAccessUser) {
    return user.is_logged_in;
}

export function shouldDisableSignupPasswordFields(user: SignupAccessUser) {
    return user.is_logged_in;
}